import { motion, useReducedMotion } from 'framer-motion';

type WizardProgressProps = {
  currentStepIndex: number;
  totalSteps: number;
};

export function WizardProgress({ currentStepIndex, totalSteps }: WizardProgressProps) {
  const shouldReduceMotion = useReducedMotion();
  const progressPercentage =
    totalSteps > 0 ? (Math.min(currentStepIndex + 1, totalSteps) / totalSteps) * 100 : 0;

  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(progressPercentage)}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: 6,
        zIndex: 1000,
        backgroundColor: 'var(--mantine-color-gray-8)',
      }}
    >
      <motion.div
        initial={shouldReduceMotion ? false : { width: 0 }}
        animate={{ width: `${progressPercentage}%` }}
        transition={
          shouldReduceMotion ? { duration: 0 } : { duration: 0.45, ease: [0.22, 1, 0.36, 1] }
        }
        style={{
          height: '100%',
          backgroundColor: 'var(--mantine-color-brand-6)',
        }}
      />
    </div>
  );
}
